import { render, staticRenderFns } from "./OrderNav.vue?vue&type=template&id=222562b3&scoped=true&"
import script from "./OrderNav.vue?vue&type=script&lang=js&"
export * from "./OrderNav.vue?vue&type=script&lang=js&"
import style0 from "./OrderNav.vue?vue&type=style&index=0&id=222562b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222562b3",
  null
  
)

export default component.exports